import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild} from "@angular/core";
import { IMyOptions, ModalDirective } from "ng-uikit-pro-standard";
import { NewCmpService } from "src/app/services/new-cmp.service";
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: "app-download-newdrf",
  templateUrl: "./download-newdrf.component.html",
  styleUrls: ["./download-newdrf.component.scss"],
})

export class DownloadNewdrfComponent implements OnInit {
  
  @ViewChild("addModal", { static: true }) addModal!: ModalDirective;
  @Input() stateModalDownload: boolean = false;
  @Output() reponseStateModalDownload = new EventEmitter();

  form!: FormGroup;

  titleModal: string = "Descarga de Datos";
  isButtonDisabled: boolean = true;

  faena = "";

  typesInstruments: any[] = [];
  sensorTypes: any[] = [];
  instruments: any = [];
  sensors: any = [];

  currentSensorType: string = "";
  currentInstrument: string = "";
  currentSensor: string = "";

  selectedInstrument = false;
  selectedSensorType = false;
  selectedSensor = false;
  selectedType = false;

  public myDatePickerOptions: IMyOptions = {
    dateFormat: "yyyy-mm-dd",
    editableDateField: false,
    firstDayOfWeek: "mo",
    showClearDateBtn: true,
    openSelectorOnInputClick: true,
  };

  constructor(private newCmpService: NewCmpService, private fb: FormBuilder) {}

  ngOnInit(): void {

    const gis = JSON.parse(localStorage.getItem('gis') || '{}');
    this.faena = gis.typedownload;

    this.form = this.fb.group({
      mine: [this.faena],
      type: [null],
      instrument: [null],
      sensorType: [null],
      sensor: [null],
      startdate: [null],
      enddate: [null]
    });
    this.getTypeInstrumentsByMine(this.faena);
  }

  async ngOnChanges(changes: SimpleChanges) {
    console.log("changes ", changes);

    console.log('GIS');

    if (this.stateModalDownload) {
      console.log(
        "MESSAGE STATEMODAL TRUE CHANGES: " + this.stateModalDownload,
      );

      this.addModal.show();
      this.reponseStateModalDownload.emit(false);
    }
  }

  changedType(tipo: any) {
  
    console.log(tipo);
    this.selectedType = true;
    this.selectedInstrument = false;
    this.selectedSensorType = false;
    this.selectedSensor = false;

    // Limpiar dependientes
    this.instruments = [];
    this.sensorTypes = [];
    this.sensors = [];

    this.currentInstrument = '';
    this.currentSensorType = '';
    this.currentSensor = '';

    this.form.patchValue({
      instrument: null,
      sensorType: null,
      sensor: null,
    });
  
    this.getInstrumentsByTypeInstrument(
      this.form.value.mine,
      tipo.gid
    );
    
    this.updateButtonState();
  }

  changedInstrument(instrument: any) {
  
    console.log("Instrument:", instrument);
    this.selectedInstrument = true;
    this.selectedSensorType = false;
    this.selectedSensor = false;

    // Limpiar dependientes
    this.sensorTypes = [];
    this.sensors = [];
  
    this.currentSensorType = '';
    this.currentSensor = '';
  
    this.form.patchValue({
      sensorType: null,
      sensor: null,
    });
  
    this.currentInstrument = instrument.gid;
  
    if (instrument.gid === null) {
  
      const tipoInstrumentoId = this.form.get('type')?.value;
  
      this.getSensorTypesByTypeInstrument(
        this.faena,
        tipoInstrumentoId
      );
  
    } else {
  
      this.getSensorTypesByInstrument(
        this.faena,
        instrument.gid
      );
  
    }

    this.updateButtonState();
  }

  changedSensorType(sensorType: any) {
  
    console.log(sensorType);
    this.selectedSensorType = true;
    this.selectedSensor = false;

    // Limpiar dependientes
    this.sensors = [];
  
    this.currentSensor = '';

    this.form.patchValue({
      sensor: null,
    });
    
    this.currentSensorType = sensorType.gid;
  
    this.getSensorsByFilters(
      Number(this.currentInstrument),
      sensorType.gid
    );

    this.updateButtonState();
  }

  changedSensor(sensor: any) {
   
    console.log("Sensor:", sensor);
    this.selectedSensor = true;

    this.currentSensor = sensor.gid;
    this.updateButtonState();
  }

  getTypeInstrumentsByMine(faena: string) {
    console.log("Obteniendo instrumentos para la faena: ", faena);

    this.newCmpService.getTypeInstrumentsByMine(faena).subscribe({
      next: (resp) => {
        this.typesInstruments = resp;
        console.log("Instruments by mine: " + resp);
      },
      error: (err) => {
        console.log("Received an error: " + err.message);
      },
      complete: () => {
        console.log("Completed");
      },
    });
  }

  getSensorTypesByTypeInstrument(faena: string, tipoInstrumentoId: number) {
    console.log(
      "Obteniendo tipos de sensores para la faena:",
      faena,
      "tipo instrumento:",
      tipoInstrumentoId
    );
  
    this.newCmpService
      .getSensorTypesByTypeInstrument(faena, tipoInstrumentoId)
      .subscribe({
        next: (resp) => {
          this.sensorTypes = resp;
          console.log("Sensor Types by type instrument:", resp);
        },
        error: (err) => {
          console.log("Received an error: " + err.message);
        },
        complete: () => {
          console.log("Completed");
        },
      });
  }

  getInstrumentsByTypeInstrument(faena: string, tipoInstrumentoId: number) {
    console.log(
      "Obteniendo instrumentos para la faena:",
      faena,
      "tipo:",
      tipoInstrumentoId,
    );

    this.newCmpService
      .getInstrumentsByTypeInstrument(faena, tipoInstrumentoId)
      .subscribe({
        next: (resp) => {
            this.instruments = [
              { gid: null, codigo: 'Todos' },
              ...resp
            ];
          console.log("Instruments:", resp);
        },
        error: (err) => {
          console.log("Received an error:", err.message);
        },
        complete: () => {
          console.log("Completed");
        },
      });
  }

  getSensorTypesByInstrument(faena: string, instrumentoId: number) {

    console.log("Obteniendo tipos de sensores para:", instrumentoId);
  
    this.newCmpService
      .getSensorTypesByInstrument(faena, instrumentoId)
      .subscribe({
        next: (resp) => {
          this.sensorTypes = [
            // { gid: null, nombre: 'Todos' },
            ...resp
          ];
          console.log("Sensor Types:", resp);
        },
        error: (err) => {
          console.log("Received an error:", err.message);
        },
        complete: () => {
          console.log("Completed");
        },
      });
  }

  getSensorsByFilters(instrumentoId: number, tipoSensorId: number) {
    this.newCmpService
      .getSensors(
        this.faena,
        instrumentoId,
        tipoSensorId
      )
      .subscribe({
        next: (resp) => {
          this.sensors = [
            { gid: null, codigo: 'Todos' },
            ...resp
          ];
          console.log("Sensors:", resp);
        },
        error: (err) => {
          console.log("Received an error:", err.message);
        },
        complete: () => {
          console.log("Completed");
        },
      });
  }

  download() {

    this.isButtonDisabled = true;
  
    const startdateRaw = this.form.get('startdate')?.value;
    const enddateRaw = this.form.get('enddate')?.value;
    
    const startdate = startdateRaw
      ? `${startdateRaw.split(' ')[0]}T00:00:00`
      : undefined;
    
    const enddate = enddateRaw
      ? `${enddateRaw.split(' ')[0]}T23:59:59`
      : undefined;
    
    console.log('Start Date:', startdate);
    console.log('End Date:', enddate);
    
      this.newCmpService
        .descargarDatos(
          this.faena,
          this.currentSensorType,
          {
            instrumento_id: this.currentInstrument,
            sensor_id: this.currentSensor,
            startdate,
            enddate,
          }
        )
        .subscribe({
          next: (blob) => {
    
            const url = window.URL.createObjectURL(blob);
    
            const a = document.createElement("a");
    
            a.href = url;
            a.download = "datos.csv";
            a.click();
    
            window.URL.revokeObjectURL(url);
            this.updateButtonState();
          },
          error: (err) => {
            console.error(err);
            this.updateButtonState();
          },
        });
  }

  updateButtonState() {

    this.isButtonDisabled = !(
      this.selectedType &&
      this.selectedInstrument &&
      this.selectedSensorType &&
      this.selectedSensor
    );
  }
  
}